import React, { Fragment } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { SECOND_LIST_CLASS_NAME, getFirstFromEachGroup } from './helpers';

const TokenEntry = ({ mention, theme, searchValue, isFocused, tokens, ...parentProps }) => {
  const mentionGroup = _.kebabCase(mention.groupName);

  const render = (
    <div {...parentProps} key={`${mention.name}-${mentionGroup}`}>
      <div className={`${SECOND_LIST_CLASS_NAME}__container`}>
        <div className={`${SECOND_LIST_CLASS_NAME}__text`}>{mention.name}</div>
      </div>
    </div>
  );

  if (_.includes(getFirstFromEachGroup(tokens), _.kebabCase(mention.name))) {
    return (
      <Fragment>
        <div className={`${SECOND_LIST_CLASS_NAME}__title`}>{mention.groupName}</div>
        {render}
      </Fragment>
    );
  }
  return render;
};

TokenEntry.propTypes = {
  mention: PropTypes.shape({}),
};

export default TokenEntry;
